import FormMQ24GConfigAlerts from "./FormMQ24GConfigAlerts";
import FormMQConfigAlerts from "./FormMQConfigAlerts";

const FormParams = ({item, _TC}) => {
    switch (item.model) {
        case "MQ2-4G":
            return <FormMQ24GConfigAlerts item={item} _TC={_TC} />;
        case "MQ-SX":
            return <FormMQConfigAlerts item={item} _TC={_TC} />;
        default:
            return <></>;
    }
};
export default FormParams;
